const Tabby = require('tabbyjs');
initTabs();

function initTabs() {
    let tabsList = document.querySelectorAll('[data-tabs]');
    if (tabsList && tabsList.length > 0) {
        var tabs = new Tabby('[data-tabs]');
        if (document.getElementsByClassName('tabs').length) {
            const tabSelectors = document.querySelectorAll('ul.tabs') as NodeList;
            tabSelectors.forEach((tab, i) => {
                let selector = `data-tabs-${i}`;
                (tab as HTMLElement).setAttribute(selector, '');
                new Tabby(`[data-tabs-${i}]`);
            });

            //Scroll the tabs along when mobile/desktop users click
            document.querySelectorAll('.tabs li').forEach((tabItem) => {
                tabItem.addEventListener('click', (elem) => {
                    if (window.matchMedia("(min-width: 1024px)").matches) {
                        let viewport = ((elem.currentTarget as HTMLElement).parentNode as HTMLElement).parentElement;
                        let offset = (elem.currentTarget as HTMLElement).offsetLeft;
                        if (viewport && (offset > ((elem.currentTarget as HTMLElement).parentNode as HTMLElement).scrollWidth - viewport.clientWidth)) {
                            offset = ((elem.currentTarget as HTMLElement).parentNode as HTMLElement).scrollWidth - viewport.clientWidth;
                        }
                        ((elem.currentTarget as HTMLElement).parentNode as HTMLElement).style.transform = 'translate(-' + offset + 'px)';
                        let prevButton = ((elem.currentTarget as HTMLElement).parentNode as HTMLElement).previousElementSibling as HTMLElement;
                        let nextButton = ((elem.currentTarget as HTMLElement).parentNode as HTMLElement).nextElementSibling as HTMLElement;
                        checkButtons((elem.currentTarget as HTMLElement).parentNode as HTMLElement, nextButton, prevButton);
                    }
                    else {
                        ((elem.currentTarget as HTMLElement).parentNode as HTMLElement).scrollLeft = (elem.currentTarget as HTMLElement).offsetLeft;
                    }
                });
            });

            window.onresize = checkScrollingTabContainers;
            checkScrollingTabContainers();
        }
    }
}

function checkScrollingTabContainers(): void {
    document.querySelectorAll('.scrolling-tab-container').forEach((tabContainer) => {
        let tablisting: any = tabContainer.getElementsByClassName('tabs').item(0);
        (tablisting as HTMLElement).removeAttribute('style');
        let prevButton = tabContainer.getElementsByClassName('tab-previous').item(0);
        (prevButton as HTMLElement).classList.remove('disabled');
        let nextButton = tabContainer.getElementsByClassName('tab-next').item(0);
        (nextButton as HTMLElement).classList.remove('disabled');
        if (!tablisting) {
            (prevButton as HTMLElement).classList.add('disabled');
            (nextButton as HTMLElement).classList.add('disabled');
        }
        else {
            //initial state
            (prevButton as HTMLElement).classList.add('disabled');
            if (getLastVisibleTab(tablisting) == tablisting.children.length - 1) {
                (nextButton as HTMLElement).classList.add('disabled');
            }
        }

        //click events
        nextButton?.addEventListener('click', (elem) => {
            elem.preventDefault();
            let buttonElem = (elem.currentTarget as HTMLElement);
            let tablist: any = buttonElem.previousElementSibling;
            let prevButton: HTMLElement = tablist.previousElementSibling;
            let index = getLastVisibleTab(tablist);
            if (index < tablist.children.length - 1) {
                let viewport = (tablist as HTMLElement).parentElement;
                let offset = tablist.children[index + 1].offsetLeft;
                if (viewport && offset > (tablist as HTMLElement).scrollWidth - viewport.clientWidth + 45) {
                    offset = (tablist as HTMLElement).scrollWidth - viewport.clientWidth + 45;
                }
                (tablist as HTMLElement).style.transform = 'translate(-' + offset + 'px)';
                checkButtons((tablist as HTMLElement), buttonElem, prevButton);
            }
            else {
                buttonElem.classList.add('disabled');
            }
        });
        prevButton?.addEventListener('click', (elem) => {
            elem.preventDefault();
            let buttonElem = (elem.currentTarget as HTMLElement);
            let tablist: any = buttonElem.nextElementSibling;
            let nextButton: HTMLElement = tablist.nextElementSibling;
            let index = getFirstVisibleTab(tablist);
            if (index > 0) {
                let viewport = (tablist as HTMLElement).parentElement;
                let offset = tablist.children[index - 1].offsetLeft;
                if (viewport && offset < 0) {
                    offset = 0;
                }
                (tablist as HTMLElement).style.transform = 'translate(-' + offset + 'px)';
                checkButtons((tablist as HTMLElement), nextButton, buttonElem);
            }
            else {
                buttonElem.classList.add('disabled');
            }
        });
    });
}

function getFirstVisibleTab(tabList: any): number {
    let index = 0;
    let viewport = (tabList as HTMLElement).parentElement;
    for (let child of tabList.children) {
        if (viewport && tabList &&
            (child.getBoundingClientRect().x) >= viewport.getBoundingClientRect().x) {
            break;
        }
        index++;
    }
    return index;
}

function getLastVisibleTab(tabList: any): number {
    let count = (tabList as any).children.length - 1;
    let ctr = count;
    let viewport = (tabList as HTMLElement).parentElement;
    for (ctr = count; ctr >= 0; ctr--) {
        if (viewport && tabList && tabList.children[ctr]) {
            if ((tabList.children[ctr].getBoundingClientRect().x + tabList.children[ctr].getBoundingClientRect().width + 20) <=
                (viewport.getBoundingClientRect().x + viewport.getBoundingClientRect().width)) {
                break;
            }
        }
    }
    return ctr;
}

function checkButtons(tablist: HTMLElement, nextButton: HTMLElement, prevButton: HTMLElement): void {
    setTimeout(() => {
        if (getLastVisibleTab(tablist) == (tablist.children.length - 1)) {
            nextButton?.classList.add('disabled');
        }
        else {
            nextButton?.classList.remove('disabled');
        }
        if (getFirstVisibleTab(tablist) > 0) {
            prevButton?.classList.remove('disabled');
        }
        else {
            prevButton?.classList.add('disabled');
        }
    }, 500);
}


export { initTabs };